<template>
  <div>
    <div class="d-flex flex-row-column justify-content-between">
      <span class="page-title mt-3 pt-1 ml-4">Deposit Slips History</span>
      <span class="d-flex flex-row-column mt-2 mr-4">
        <span class="input-width-160 r-width-100 d-inline-block mr-3">
          <date-range v-on:input="filterResults($event,'date_range')" text="Filter by Date" />
        </span>
        <span class="input-width-160 r-width-100 d-inline-block">
          <md-field>
            <label>Search</label>
            <md-input v-on:keyup="search" v-model="search_term"></md-input>
            <md-icon>search</md-icon>
          </md-field>
        </span>
      </span>
    </div>
    <hr class="hr-line" />
    <md-table
      :md-sort-fn="orderBy"
      :md-sort.sync="currentSort"
      :md-sort-order.sync="currentSortOrder"
      class="pl-3"
      v-show="!loading"
      v-if="items.length>0"
      v-model="items"
    >
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="Deposit Date" md-sort-by="date_issued">{{ item.date_issued }}</md-table-cell>
        <md-table-cell md-label="Status" md-sort-by="status">{{ item.status }}</md-table-cell>
       <md-table-cell md-label="Type" md-sort-by="type">{{ item.type }}</md-table-cell>
        <md-table-cell md-label="Authorization Code" md-sort-by="auth_code">{{ item.auth_code }}</md-table-cell>
        <md-table-cell md-label="Total Amount" md-sort-by="total_amount">{{item.total_amount}}</md-table-cell>
        <md-table-cell :md-label="$t('general.lmt_name')" md-sort-by="lmt_name">{{item.lmt_name}}</md-table-cell>
        <md-table-cell
          md-label="Transaction Number"
          md-sort-by="transactions_count"
        >{{item.transactions_count}}</md-table-cell>
        <md-table-cell md-label="Details">
          <router-link :to="'/agent/slip/'+item.id">View Slip</router-link>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <pagination
      v-on:change="paginationChange($event)"
      v-on:change_per_page="changePerPage($event)"
      v-if="items.length>0&&pagination"
      :meta="pagination.meta"
      :links="pagination.links"
      :per_page="per_page"
    />

    <empty-state v-if="!loading&&items.length==0" />

    <loading v-if="loading" />
  </div>
</template>
<script>
// import pagination methods paginationChange and changePerPage
import Pagination from "../../mixins/pagination.js";

// mixin for loading datas and state
import DataMixin from "../../mixins/data.js";

export default {
  mixins: [Pagination, DataMixin],
  data() {
    return {
      search_term: "",
      // url for loading data
      api_url: "/agent/deposits",
      //IMPORTANT loaded data is stored in items
      items: []
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    filterResults(event) {
      this.$router.push({
        path: this.$route.curentPath,
        query: { start_date: event[0], end_date: event[1] }
      });
      this.loadData();
    }
  }
};
</script>